"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Object.defineProperties(exports, _defineProperty({
  __esModule: {
    value: !0
  }
}, Symbol.toStringTag, {
  value: "Module"
}));

var e = require("./lite-DyshwcGq.js"),
    l = require("./plugins.js"),
    n = "number-flow-connect",
    s = "number-flow-update",
    f = function f(r) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      t = _ref.locales,
      o = _ref.format,
      a = _ref.numberPrefix,
      u = _ref.numberSuffix;

  var c = e.formatToData(r, new Intl.NumberFormat(t, o), a, u);
  return e.renderInnerHTML(c);
};

var i = /*#__PURE__*/function (_e$NumberFlowLite) {
  _inherits(i, _e$NumberFlowLite);

  var _super = _createSuper(i);

  function i() {
    var _this;

    _classCallCheck(this, i);

    _this = _super.apply(this, arguments), _this.connected = !1;
    return _this;
  }

  _createClass(i, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.connected = !0, this.dispatchEvent(new Event(n, {
        bubbles: !0
      }));
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.connected = !1;
    }
  }, {
    key: "value",
    get: function get() {
      return this._value;
    }
  }, {
    key: "update",
    value: function update(t) {
      (!this._formatter || this._prevFormat !== this.format || this._prevLocales !== this.locales) && (this._formatter = new Intl.NumberFormat(this.locales, this.format), this._prevFormat = this.format, this._prevLocales = this.locales), t != null && (this._value = t), this.dispatchEvent(new Event(s, {
        bubbles: !0
      })), this.data = e.formatToData(this._value, this._formatter, this.numberPrefix, this.numberSuffix);
    }
  }]);

  return i;
}(e.NumberFlowLite);

e.define("number-flow", i);
exports.Digit = e.Digit;
exports.canAnimate = e.canAnimate;
exports.define = e.define;
exports.formatToData = e.formatToData;
exports.prefersReducedMotion = e.prefersReducedMotion;
exports.continuous = l.continuous;
exports.CONNECT_EVENT = n;
exports.UPDATE_EVENT = s;
exports.default = i;
exports.renderInnerHTML = f;